import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import { Anchor } from "../../../Shared/Common/Anchor";
import { FormattedMessage, useIntl } from "react-intl";

import { NML_PAGE } from "../../../../interfaces/Static/routing_paths";

import ItoSanImage from "../../../../assets/images/nml/alumni-recruitment/itosan.webp";
import MiyasakaSanImage from "../../../../assets/images/nml/alumni-recruitment/miyasakasan.webp";
const employees = [
  {
    name: "page.nml.alumni_recruitment.interview.ito.name",
    image: ItoSanImage,
    left: 2021,
    rejoined: 2024,
    previousJob: "page.nml.alumni_recruitment.interview.ito.previous_job",
    href: `${NML_PAGE}/alumni-interview/ito`,
    external: false,
  },
  {
    name: "page.nml.alumni_recruitment.interview.miyasaka.name",
    image: MiyasakaSanImage,
    left: 2019,
    rejoined: 2024,
    previousJob: "page.nml.alumni_recruitment.interview.miyasaka.previous_job",
    href: `${NML_PAGE}/alumni-interview/miyasaka`,
    external: false,
  },
];

const ReturneeCards = () => {
  const intl = useIntl();
  const { locale } = intl;
  return (
    <Container className="alumni-interview-block">
      <Row>
        <Splide
          options={{
            arrows: false,
            pagination: employees.length > 2,
            width: "100%",
            perPage: 2,
            type: employees.length > 2 ? "loop" : "slide",
            rewind: false,
            autoplay: employees.length > 2,
            pauseOnHover: false,
            resetProgress: false,
            gap: "1rem",
            interval: 5000,
            breakpoints: {
              1024: {
                perPage: 2,
              },
              768: {
                perPage: 1,
                pagination: true,
                autoplay: true,
                type: "loop",
              },
            },
          }}
        >
          {employees.map((emp) => {
            return (
              <SplideSlide key={emp.name}>
                <Col key={emp.name}>
                  <Anchor href={emp.href} external={emp.external}>
                    <Card className="shadow-sm border-0 returnee-card">
                      <Card.Body className="returnee-body">
                        <Card.Img
                          variant="top"
                          src={emp.image}
                          className="returnee-img"
                        />
                        <Card.Title className="bold pt-4 pb-3">
                          <FormattedMessage id={emp.name} />
                        </Card.Title>
                        <Card.Text className="mb-1">
                          {locale === "ja" ? (
                            <>
                              {emp.left}{" "}
                              <FormattedMessage id="page.nml.alumni_recruitment.interview.left_in" />{" "}
                              {emp.rejoined}{" "}
                              <FormattedMessage id="page.nml.alumni_recruitment.interview.rejoined_in" />
                            </>
                          ) : (
                            <>
                              <FormattedMessage id="page.nml.alumni_recruitment.interview.left_in" />{" "}
                              {emp.left}{" "}
                              <FormattedMessage id="page.nml.alumni_recruitment.interview.rejoined_in" />{" "}
                              {emp.rejoined}
                            </>
                          )}
                        </Card.Text>
                        <Card.Text className="mb-0">
                          <FormattedMessage id="page.nml.alumni_recruitment.interview.previous_job" />
                          : <FormattedMessage id={emp.previousJob} />
                        </Card.Text>
                      </Card.Body>
                    </Card>
                  </Anchor>
                </Col>
              </SplideSlide>
            );
          })}
        </Splide>
      </Row>
    </Container>
  );
};

export default ReturneeCards;
